import { validateProps } from '../utils';
export const isValidBase = entity => validateProps(entity, ['id', 'revision']);
//# sourceMappingURL=BaseEntity.js.map